(function () {
  const HERO_SELECTOR = '[data-hero-spotlight]';

  function initHeroSpotlight(spotlight) {
    if (!spotlight || spotlight.dataset.heroInitialized === 'true') return;

    const cards = Array.from(spotlight.querySelectorAll('[data-hero-card]'));
    if (cards.length <= 1) {
      spotlight.dataset.heroInitialized = 'true';
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = !prefersReducedMotion;
    const rawIntervalMs = parseInt(spotlight.dataset.heroInterval || '', 10);
    const intervalMs = Math.max(Number.isFinite(rawIntervalMs) ? rawIntervalMs : 1400, 1000);
    const swapDurationMs = 240;
    let activeIndex = cards.findIndex((card) => card.classList.contains('is-active'));
    let timerId = null;
    let isTransitioning = false;

    if (activeIndex < 0) activeIndex = 0;

    function updateDeckClasses(indexToShow) {
      cards.forEach((card, index) => {
        const offset = (index - indexToShow + cards.length) % cards.length;

        card.classList.remove('is-active', 'is-next', 'is-peek', 'is-stack-hidden', 'is-leaving-right');

        if (offset === 0) {
          card.classList.add('is-active');
          card.setAttribute('aria-hidden', 'false');
        } else if (offset === 1) {
          card.classList.add('is-next');
          card.setAttribute('aria-hidden', 'true');
        } else if (offset === 2) {
          card.classList.add('is-peek');
          card.setAttribute('aria-hidden', 'true');
        } else {
          card.classList.add('is-stack-hidden');
          card.setAttribute('aria-hidden', 'true');
        }
      });

    }

    function setActive(nextIndex) {
      if (nextIndex < 0 || nextIndex >= cards.length || nextIndex === activeIndex || isTransitioning) return;

      if (prefersReducedMotion) {
        updateDeckClasses(nextIndex);
        activeIndex = nextIndex;
        return;
      }

      const leavingCard = cards[activeIndex];
      isTransitioning = true;
      if (leavingCard) {
        const rect = leavingCard.getBoundingClientRect();
        const targetRightOffset = Math.max(window.innerWidth - rect.left + 24, rect.width + 80);
        spotlight.style.setProperty('--hero-leave-x', `${targetRightOffset}px`);
        leavingCard.classList.add('is-leaving-right');
        leavingCard.setAttribute('aria-hidden', 'true');
      }

      window.setTimeout(() => {
        if (leavingCard) leavingCard.classList.remove('is-leaving-right');
        updateDeckClasses(nextIndex);
        activeIndex = nextIndex;
        isTransitioning = false;
      }, swapDurationMs);
    }

    function nextCard() {
      const nextIndex = (activeIndex + 1) % cards.length;
      setActive(nextIndex);
    }

    function stopAutoplay() {
      if (!timerId) return;
      window.clearInterval(timerId);
      timerId = null;
    }

    function startAutoplay() {
      if (!autoplayEnabled || timerId) return;
      timerId = window.setInterval(nextCard, intervalMs);
    }

    spotlight.addEventListener('mouseenter', stopAutoplay);
    spotlight.addEventListener('mouseleave', startAutoplay);
    spotlight.addEventListener('focusin', stopAutoplay);
    spotlight.addEventListener('focusout', startAutoplay);

    updateDeckClasses(activeIndex);
    startAutoplay();
    spotlight.dataset.heroInitialized = 'true';
  }

  function initAllSpotlights(root) {
    const scope = root || document;
    const spotlights = scope.querySelectorAll(HERO_SELECTOR);
    spotlights.forEach(initHeroSpotlight);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllSpotlights(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllSpotlights(event.target);
  });
})();
